import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=814571f8&scoped=true&"
import script from "./ProductOffers.vue?vue&type=script&lang=js&"
export * from "./ProductOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814571f8",
  null
  
)

export default component.exports